import { WebshopProduct } from '@/modules/apiTypes';
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from 'react';

export type CrossSellModalTexts = {
  title: string;
  description: string;
};

interface CrossSellContextProps {
  crossSellModalTexts: CrossSellModalTexts | undefined;
  crossSellProducts: WebshopProduct[];
  setProduct: (product: WebshopProduct | undefined) => void;
}

const CrossSellContext = createContext<CrossSellContextProps>({
  crossSellModalTexts: undefined,
  crossSellProducts: [],
  setProduct: () => undefined,
});

const CrossSellContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [product, setProduct] = useState<WebshopProduct>();

  const crossSellModalTexts: CrossSellModalTexts | undefined = useMemo(() => {
    if (!product) {
      return undefined;
    }

    return {
      title: product.cross_sell_title,
      description: product.cross_sell_description,
    };
  }, [product]);

  return (
    <CrossSellContext.Provider
      value={{
        crossSellModalTexts: crossSellModalTexts,
        crossSellProducts:
          product?.cross_sell_products?.map((csp) => csp.product) ?? [],
        setProduct: setProduct,
      }}
    >
      {children}
    </CrossSellContext.Provider>
  );
};

export const useCrossSellContext = () => useContext(CrossSellContext);

export { CrossSellContextProvider };
